import { SHStack } from "@components/design-systems";
import {
  AnalysisSummaryDTO,
  RenderAnalysisSummaryItemProps,
} from "@models/platform-analysis/entities/steps/summary";
import { Collapse } from "@mui/material";
import { RootState } from "@redux/store";
import { memo } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { AppendixFeatureAnalysisTable } from "./analysis-table";
import { AppendixFeatureAnalysisSectionTitle } from "./section-title";

export const SummaryAppendixFeatureAnalysis = memo(
  ({ disabled: sectionDisabled }: RenderAnalysisSummaryItemProps) => {
    const { control } = useFormContext<AnalysisSummaryDTO>();
    const disqualifiedProductChunk = useSelector(
      (state: RootState) =>
        state.platformAnalysis.ui.summary.featureAnalysis
          .disqualifiedProductChunk,
    );

    const totalProduct = disqualifiedProductChunk.reduce(
      (sum, arr) => sum + arr.length,
      0,
    );

    const watchedShowAppendixFeatureAnalysis = useWatch({
      control,
      name: "showAppendixFeatureAnalysis",
    });

    return (
      <>
        <Controller
          name="showAppendixFeatureAnalysis"
          control={control}
          render={({ field: { value, onChange } }) => (
            <SHStack width={"100%"}>
              <SHStack flexDirection={"row"} justifyContent={"space-between"}>
                <AppendixFeatureAnalysisSectionTitle
                  disabled={sectionDisabled}
                  total={totalProduct}
                  showAppendixFeatureAnalysis={value ?? true}
                  onChange={(value: boolean) => {
                    onChange(value);
                  }}
                />
              </SHStack>
            </SHStack>
          )}
        />

        <Collapse unmountOnExit in={!!watchedShowAppendixFeatureAnalysis}>
          <SHStack gap={2}>
            {disqualifiedProductChunk.map((item, index) => {
              return (
                <SHStack
                  flexDirection={"column"}
                  justifyContent={"space-between"}
                  gap={2}
                  key={index}
                >
                  {!!index && (
                    <AppendixFeatureAnalysisSectionTitle
                      index={index}
                      disabled={sectionDisabled}
                      total={totalProduct}
                      showAppendixFeatureAnalysis={
                        !!watchedShowAppendixFeatureAnalysis
                      }
                    />
                  )}

                  <AppendixFeatureAnalysisTable
                    index={index}
                    selectedProducts={item}
                  />
                </SHStack>
              );
            })}
          </SHStack>
        </Collapse>
      </>
    );
  },
);
